<form fxLayout="column" name="itinerary-settings-general-form">
  <mat-form-field appearance="outline">
    <mat-label>Lingua</mat-label>

    <mat-select [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
      [(ngModel)]="itinerary.locale" name="locale">
      <mat-option [value]="null">(default, it)</mat-option>
      <mat-option *ngFor="let locale of ['it', 'en']" [value]="locale">
        {{ locale }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Partner</mat-label>

    <mat-select [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
      [(ngModel)]="itinerary.partner" name="partner">
      <mat-option [value]="null"> </mat-option>
      <mat-option *ngFor="let partner of partnersData" [value]="partner.key">
        {{ partner.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Archiviato?</mat-label>
    <textarea matInput hidden></textarea>
    <mat-slide-toggle [checked]="itinerary.archived" (change)="itinerary.archived = $event.checked">{{
      itinerary.archived ? "Sì" : "No" }}</mat-slide-toggle>
  </mat-form-field>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>E' un itinerario di test?</mat-label>
    <textarea matInput hidden></textarea>
    <mat-slide-toggle [checked]="itinerary.test" (change)="itinerary.test = $event.checked">{{ itinerary.test ? "Sì" :
      "No" }}</mat-slide-toggle>
  </mat-form-field>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Nascondi date?</mat-label>
    <textarea matInput hidden></textarea>
    <mat-slide-toggle [checked]="itinerary.renderConfig.hideDates"
      (change)="itinerary.renderConfig.hideDates = $event.checked">{{ itinerary.renderConfig.hideDates ? "Sì" : "No" }}
    </mat-slide-toggle>
  </mat-form-field>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Nascondi upsell?</mat-label>
    <textarea matInput hidden></textarea>
    <mat-slide-toggle [checked]="itinerary.renderConfig.hideUpsells"
      (change)="itinerary.renderConfig.hideUpsells = $event.checked">{{ itinerary.renderConfig.hideUpsells ? "Sì" : "No"
      }}</mat-slide-toggle>
  </mat-form-field>
</form>